import React, { Component } from 'react'
import Icon from './Icon'

type PaginateBoxIcon = 'next' | 'previous'
type PaginateBoxIcons = Record<PaginateBoxIcon, PaginateBoxIconData>
export type PaginateBoxPage = PaginateBoxIcon | number

interface PaginateBoxIconData {
  name: string
  cursor: string
  hover: string
}

interface PaginateBoxProps {
  page: PaginateBoxPage
  active?: boolean
  onClick: (page: PaginateBoxPage) => void
}

export default class PaginateBox extends Component<PaginateBoxProps> {
  icons: PaginateBoxIcons = {
    next: {
      name: 'arrow-right-s',
      cursor: 'cursor-pointer',
      hover: 'hover:bg-tertiary'
    },
    previous: {
      name: 'arrow-left-s',
      cursor: 'cursor-pointer',
      hover: 'hover:bg-tertiary'
    }
  }

  constructor (props: PaginateBoxProps) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
  }

  get className () {
    const base = 'border inline-flex justify-center items-center h-8 w-8 -m-px'
    const hover = this.iconData ? this.iconData.hover : 'hover:bg-tertiary'
    const active = this.props.active
      ? 'bg-primary text-white border-secondary hover:bg-primary'
      : `bg-white text-secondary border-primary ${hover}`
    const cursor = this.iconData ? this.iconData.cursor : 'cursor-pointer'
    return `${base} ${active} ${cursor}`
  }

  get isPageNumber () {
    const { page } = this.props
    return typeof page === 'number'
  }

  get iconData () {
    const { page } = this.props
    return !this.isPageNumber && this.icons[page as PaginateBoxIcon]
  }

  get icon () {
    return this.iconData &&
      <Icon
        name={this.iconData.name}
        size="medium"
        color="inherit" />
  }

  get pageNumber () {
    return <span>{this.props.page}</span>
  }

  get label () {
    return this.isPageNumber ? this.pageNumber : this.icon
  }

  handleClick () {
    this.props.onClick(this.props.page)
  }

  render () {
    return (
      <div
        className={this.className}
        onClick={this.handleClick}>
        {this.label}
      </div>
    )
  }
}
